module.exports = __webpack_public_path__ + "img/Race.28dfb50d.svg";